window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));


    //get varient directly from list
    var _this = this;
    $("[data-vitem-id]").on('click',function(e){
      if(!$(this).hasClass('selected') && !$(this).hasClass('notavailable'))
      {
          $("[data-vitem-id].selected").removeClass('selected');
          $(this).addClass('selected');
          $('.main-color.var').text( $(this).attr('data-title'));
          _this._onSelectChangeDirect($(this).attr('data-vitem-id'));

          var datas = $(this).attr('data-var-im');
          $('[data-im="'+datas+'"]').trigger('click');
      }
    });
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }


    },
      _onSelectChangeDirect: function(th) {

          var variants = this.product.variants;
          var variant = false;

          variants.forEach(function(vari) {

             if(vari.id == th)
             {
                 variant = vari;
             }

          });

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      //this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }


    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html("ADD TO BAG");
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html("SOLD OUT");
      }

      //price update
        var $comparePrice = $(selectors.comparePrice, this.$container);
        var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

        $(selectors.productPrice, this.$container)
            .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
            $compareEls.removeClass('hide');
        } else {
            $comparePrice.html('');
            $compareEls.addClass('hide');
        }

        if($('[data-add-price]').length)
        {
            $('[data-add-price]').html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      /*
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
      */
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Common ================*/
"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};
UTI.isdesktop = true;

UTI.common = {
    VAR: {
        navClosed: false,
        windowwidth: 0,
        windowheight: 0,
        $MainContent: $('#MainContent'),
        lastDeviceDesktop: true
    },
    init: function () {
        var _this = this;

        $('.simple-slider').slick({
            speed: 300,dots:true,arrows:false, slidesToScroll: 1,infinite: true,autoplay:true
        });

        $('.skin-pd-slide').slick({
            speed: 300,dots:true,arrows:false, slidesToScroll: 3, slidesToShow: 3,infinite: false,autoplay:false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,slidesToScroll: 1,adaptiveHeight: true
                    }
                }
            ]
        });

        $(window).resize(function () {
            //use nav menu text to detect mobile and desktop
            if ((jQuery(window).width() > 749) && !UTI.isdesktop) {
                UTI.isdesktop = true;
                $(window).trigger('uti-device-changed');
            }
            else if ((jQuery(window).width() < 750) && UTI.isdesktop) {
                UTI.isdesktop = false;
                $(window).trigger('uti-device-changed');
            }
            _this.checkResize();
         
        });

        $('.nlspop .close, .nl-overlay').on('click', function (e) {

            e.preventDefault();
            $('.nssucsess').remove();

        });


        setTimeout(function () {
            $(window).trigger('uti-device-changed');
            $(window).trigger('uti-width-changed');
        }, 100);

        //common function to change all the image with the dievice change
        $(window).on('uti-device-changed', function () {

            if (UTI.isdesktop) {
                $('[data-deskimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-deskimage'));
                });
            }
            else {
                $('[data-mobimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-mobimage'));
                });
            }

        });


        //scroll throtle
        var scrollpos = 0;
        var scrollTimeout;
        var throttle = 200;

        $(window).on('scroll', function () {
            if (!scrollTimeout) {
                scrollTimeout = setTimeout(function () {
                    var goindown = window.pageYOffset>scrollpos?true:false;
                    scrollpos = window.pageYOffset;
                    $(window).trigger('utiscroll', [window.pageYOffset, goindown]);
                    scrollTimeout = null;

                    if(window.pageYOffset >= 200)
                    {
                        $('body').addClass('scroll-down');
                    }
                    else
                    {
                        $('body').removeClass('scroll-down');
                    }
                    
                }, throttle);
            }
        });

        // simple accordion for all, use ac-title

        $( '.ac-title:not(.active)').each(function(){
            $(this).next().css('display','none');
        });

        $('body').on('click', '.ac-title', function (e) {

            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass('active')) {
                $(this).next().removeClass('active');
                $(this).next().slideUp();
                $(this).find('i').attr('class', "fa fa-angle-down");
                $(this).parent().removeClass('actb');
            }
            else {
                $(this).next().addClass('active');
                $(this).next().slideDown();
                $(this).find('i').attr('class', "fa fa-angle-up");
                $(this).parent().addClass('actb');

            }
            $(this).toggleClass('active');

        });

        //=============popup window for links with class popit-------------------------

        $('body').on('click', "[data-popit]", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var link = $(this).attr('href') + " " + $(this).attr('data-popit');

            $('<div>').dialog({
                modal: true, draggable: false,
                open: function () {
                    $(this).load(link, function() {
                       // $(".tableWrap").mCustomScrollbar({
                        //    axis: "x" // horizontal scrollbar
                        // });
                    });

                },
                height: "100%",
                width: "100%"
            });
        });
        $('body').on('click', ".ui-widget-overlay", function (e) {
            $('.ui-dialog-titlebar-close').trigger('click');
        });

        // adding default scroll x plugin for pages
        //$(".tableWrap").mCustomScrollbar({
          //  axis: "x" // horizontal scrollbar
       // });

        //=============----------------------------

        //to run with the fix popup

        $('body').on('click','[data-fixpop]',function(e){
            e.preventDefault();
            $('.'+$(this).attr('data-fixpop')).addClass('active');
            $('body').append('<div class="fix-pop-back"></div>');
            setTimeout(function(){
                $('body').addClass('pop-open');
            },100);

        });


        $('body').on('click','.fix-popup .close,.fix-pop-back',function(e){
            e.preventDefault();
            $('.fix-popup').removeClass('active');
            $('body').removeClass('pop-open');
            $('.fix-pop-back').remove();

        });

         if (jQuery('.featured-slider').length) {
            _this.callSliders();
         }

        $('body').on('click','.scrolltoanc',function(e){
            e.preventDefault();
            var tops= $($(this).attr('href')).offset().top + -150;
            $("html, body").animate({ scrollTop: tops }, 600);

        });

         // video
        $('video.click-play').click(function(e){
            $(this).toggleClass("play");
            if($(this).hasClass("play"))
            {
                $(this).get(0).play();
            }
            else
            {
                $(this).get(0).pause();
            }
        });

        //tab section

        var tabsection;
        var curtab = 0;
        $('body').on('click', '.product-split-box .tab-header >div:not(.active)', function (e) {
          $(this).parent().find('>div').removeClass('active');
          $(this).addClass('active');
          $(this).parents('.tabbox').find('.tab-content').addClass('temphide');
          tabsection = $(this).parents('.tabbox').find('.tab-content');
          curtab = $(this).index();
          setTimeout(function(){
              tabsection.find(' > div').removeClass('active');
              tabsection.find(' > div').eq(curtab).addClass('active');
              tabsection.removeClass('temphide');
              if($('.simple-slider').length) $('.simple-slider').slick('setDimensions');
          },300);

        });



    },
    checkResize: function () {
        var _this = this;
        if (_this.VAR.$MainContent.width() !== _this.VAR.windowwidth || $(window).height() !== _this.VAR.windowheight) {
            _this.VAR.windowwidth = _this.VAR.$MainContent.width();
            _this.VAR.windowheight = $(window).height();
            $(window).trigger('uti-width-changed');
        }
        _this.VAR.windowwidth = _this.VAR.$MainContent.width();
        _this.VAR.windowheight = $(window).height();
    },

    callSliders: function () {
        var _this = this;

        jQuery('.pro-slide').each(function(){
            var div = $(this).find('[data-f-src]');
            var divh = $(this).find('[data-fh-src]');
            if(UTI.isdesktop || !$(this).hasClass('.slide'))
            {
                divh.attr('src',divh.attr('data-fh-src'));
                div.attr('src',div.attr('data-f-src'));
            }
            else
            {
                if($(this).index() < 4)
                {
                    div.attr('src',div.attr('data-f-src'));
                }
            }

        });


        jQuery('.featured-slider').slick({
            prevArrow: '<div class="pdsl_prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-177.8 175.5 50 50" style="enable-background:new -177.8 175.5 50 50; fill:black;" xml:space="preserve"> <path d="M-158.3,200.5l18.5-18.5c0.8-0.8,0.8-2.2,0-3.1l-1.4-1.4c-0.8-0.8-2.2-0.8-3.1,0l-20,20l-1.4,1.4c-0.8,0.8-0.8,2.2,0,3.1l1.4,1.4l20,20c0.8,0.8,2.2,0.8,3.1,0l1.4-1.4c0.8-0.8,0.8-2.2,0-3.1L-158.3,200.5z"></path></svg></div>',
            nextArrow: '<div class="pdsl_next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-177.8 175.5 50 50" style="enable-background:new -177.8 175.5 50 50; fill:black;transform: rotate(180deg)" xml:space="preserve"> <path d="M-158.3,200.5l18.5-18.5c0.8-0.8,0.8-2.2,0-3.1l-1.4-1.4c-0.8-0.8-2.2-0.8-3.1,0l-20,20l-1.4,1.4c-0.8,0.8-0.8,2.2,0,3.1l1.4,1.4l20,20c0.8,0.8,2.2,0.8,3.1,0l1.4-1.4c0.8-0.8,0.8-2.2,0-3.1L-158.3,200.5z"></path></svg></div>',

            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,arrows:false,dots:true
                    }
                }
            ]
        });




    },


    // scroll to function
    scrollTo: function (targetElement, offset, duration) {
        var scrollAmount = 0;
        if (!isNaN(targetElement)) {
            scrollAmount = targetElement;
        } else {
            targetElement = targetElement instanceof jQuery ? targetElement : $(targetElement);
            offset = offset || 0;
            duration = duration || 200;
            scrollAmount = targetElement.offset().top - offset;
        }

        $('html, body').animate({
            scrollTop: scrollAmount
        }, duration);
    },

    instaSliders: function () {
        var _this = this;
        jQuery('.insta-set .fs-timeline').slick({
            touchThreshold: 20,
            // centerMode: true,
            // variableWidth: false,
            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',

            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 1,infinite: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 747,
                    settings: "unslick"
                }
            ]
        });

        $('.fs-timeline').addClass('slickadded');
        $('body').on('click', '.insta-set .fs-timeline .hero-next', function (e) {
            if(!$(this).hasClass('slick-disabled'))
            {
                $('html, body').scrollTop( $('html, body').scrollTop()+1);
            }

        });


    }




};

$(function () {

    if ((jQuery(window).width() > 749) && !UTI.isdesktop) {
        UTI.isdesktop = true;
        $(window).trigger('uti-device-changed');
    }
    else if ((jQuery(window).width() < 750) && UTI.isdesktop) {
        UTI.isdesktop = false;
        $(window).trigger('uti-device-changed');
    }
    UTI.common.init();

    jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};
});


$(document).ready(function () {

    PROJ.quicksearch.init();

    $('body').on('click', '.mob-bur, .close-mob', function () {
        if($('body').hasClass('mob-open'))
        {
            $('body').toggleClass('mob-open');
            setTimeout(function(){
                $('body').toggleClass('mob-open-body');
            },100);
        }
        else
        {
            $('body').toggleClass('mob-open-body');
            setTimeout(function(){
                $('body').toggleClass('mob-open');
            },50);
        }
    });

    $('.cselect').click(function(){
        $(this).toggleClass('mobclick');
    });



    //announce bar
    if($('[data-announce]').length)
    {
        var timer = parseInt($('[data-announce]').attr('data-announce'))*1000;
        var sets = $('.announce-bar .announce');
        var item = 0;

        setInterval(function(){
            sets.eq(item).animate({
                opacity: 0
            }, 250, function() {
                sets.eq(item).hide();
                item++;
                if(item >= sets.length)
                {
                  item = 0;
                }
                sets.eq(item).show();
                sets.eq(item).stop(true,true).animate({
                    opacity: 1
                },250   );

            });

        },timer);
    }

    $('body').on('click', '.mainnav-mob .level1 ', function (a) {

        if( $(this).hasClass('closed'))
        {
            $('.mainnav-mob .level1').addClass('closed');
            $(this).removeClass('closed');
        }
        else
        {
            $('.mainnav-mob .level1').addClass('closed');
        }


    });


});

"use strict"

var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.quicksearch = {
    VAR: {},
    init: function () {
        
        var quicid = '#quick-search-c';
        var quicinut = $(quicid);
        var results = $('.search-box .results');

        var setint = setTimeout(function(){},100);

        $(document).on("change, mouseup, keyup", quicid, function(){
            loadQuick();
        });


        var olddata = "";
        function loadQuick()
        {
            var texts = quicinut.val();
            if(texts.length > 2)
            {
                var urls = "/search?view=quick&type=product&q="+texts+"*";

                $.get(urls , function (data) {
                    if(olddata != $(data).text())
                    {
                       results.html($(data));
                    }
                    olddata = $(data).text();


                }).done(function () {
                    //results.stop().animate({opacity:1});
                });

            }else
            {
                results.html("");
                olddata = "";
            }


        }

        $(document).on("click", '.search-ico,.search-input .close', function(e){
            e.preventDefault();
            $('.search-box').toggleClass('active');
            quicinut.focus();
        });




    }
};




"use strict"

var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.producthover = {
    VAR: {},
    init: function () {


        //PLP
        // if ($('.pro-slide').length && UTI.isdesktop) {
        if (UTI.isdesktop) {

            $(document).on('mouseenter', '.pro-slide, .pro-sk-slide', function () {
                $(this).addClass('rolls');
                var myWrapper = $(this).find('.hovers img');
                myWrapper.stop().fadeIn();
            });


            $(document).on('mouseleave', '.pro-slide, .pro-sk-slide', function () {
                $(this).removeClass('rolls');

                var myWrapper = $(this).find('.hovers img');
                myWrapper.stop().fadeOut();
            });
        }


    }
};

$(function () {
    PROJ.producthover.init();
});


"use strict"

var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.collection = {
    VAR: {},
    init: function () {


        Shopify.queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
        jQuery('#sort-by')
            .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
            .bind('change', function () {
                Shopify.queryParams.sort_by = jQuery(this).val();
                location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
            });


        $('#sort-by').val(sort_by_col);
    }
};




"use strict"

var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.products = {
    VAR: {},
    init: function () {

        $('#Quantity').select2({
            minimumResultsForSearch: Infinity
        });

        var _this = this;

        //write review
        $('.write-review').click(function(e){
            e.preventDefault();
            $('.stamped-summary-actions-newreview').trigger('click');
        });

        $('.product-top .gallery-wrap .gallery .image .gallery-big').slick({

            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true, dots: false, touchThreshold: 20,
            arrows: false, adaptiveHeight: true, fade: true,
            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#dedede"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#dedede"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            responsive: [
                {
                    breakpoint: 747,
                    settings: {
                        slidesToShow: 1, dots: true, arrows: false, fade: false
                    }
                }
            ]
        });

        $('.thumbs .thumb-slick').slick({

            slidesToShow: 5, slidesToScroll: 1,
            // appendArrows: $(".slick-arrow-wrap"),
            prevArrow: '<div class="pd_prev"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 292.362 292.361" style="transform: rotate(-90deg); enable-background:new 0 0 292.362 292.361;" xml:space="preserve"><g><path d="M286.935,197.287L159.028,69.381c-3.613-3.617-7.895-5.424-12.847-5.424s-9.233,1.807-12.85,5.424L5.424,197.287 C1.807,200.904,0,205.186,0,210.134s1.807,9.233,5.424,12.847c3.621,3.617,7.902,5.425,12.85,5.425h255.813 c4.949,0,9.233-1.808,12.848-5.425c3.613-3.613,5.427-7.898,5.427-12.847S290.548,200.904,286.935,197.287z"/></g></svg></div>',
            nextArrow: '<div class="pd_next"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 292.362 292.361" style="transform: rotate(90deg); enable-background:new 0 0 292.362 292.361;" xml:space="preserve"><g><path d="M286.935,197.287L159.028,69.381c-3.613-3.617-7.895-5.424-12.847-5.424s-9.233,1.807-12.85,5.424L5.424,197.287 C1.807,200.904,0,205.186,0,210.134s1.807,9.233,5.424,12.847c3.621,3.617,7.902,5.425,12.85,5.425h255.813 c4.949,0,9.233-1.808,12.848-5.425c3.613-3.613,5.427-7.898,5.427-12.847S290.548,200.904,286.935,197.287z"/></g></svg></div>',
            asNavFor: '.product-top .gallery .image .gallery-big',
            focusOnSelect: true, infinite: true, vertical: true
        });


        $(window).on('uti-device-changed', function () {
            if (UTI.isdesktop) {
                var $easyzoom = $('.easyzoom').easyZoom();
                var api = $easyzoom.data('easyZoom');
            }
        })

        checkvideoratios();
        $(window).resize(function () {
            checkvideoratios();
        });
        
        function checkvideoratios()
        {
            $('[data-vid-ra]').each(function(){
               var $th = $(this);
               var rat = Number($th.attr('data-vid-ra'));
               var winscale = $(window).width()/$(window).height();
               var sca = winscale<rat?"ver":"hori";
               $th.attr('data-scale',sca);
            });
        }

        

        if (Modernizr.touchevents) {
            $('.zoomLoaderMessage').hide();
            $('.easyzoom a').click(function (e) {
                e.preventDefault();
            });
        }

        if ($('.gallery-wrap-new').length) {
            _this.templatetwo();
        }

        _this.upsells();


        window.addEventListener("message", receiveMessage, false);

        function receiveMessage(event) {
            
            if (event.origin !== "http://stage.matchmymakeup.com"
                && event.origin !== "https://www.matchmymakeup.com"){
                return;
            }

            var messageObject = event.data;
            var productName = messageObject.product.productName;
            var productSku = messageObject.product.sku[0];

            if (messageObject.event_id === 'add_to_cart') {
                //Custom selector on product result
                productName = productName.toLowerCase();
                var div = '[data-sku="'+productSku+'"]';
                if($(div)[0])
                {
                    $(div)[0].click();
                }else
                {
                    alert('SKU '+ productSku +' is not available');
                }


                if (typeof jQuery.colorbox !== "undefined" && jQuery.colorbox !== null) {
                    jQuery.colorbox.close();
                }
                document.mmm.overlay.close();
            }
        }


    }, relgal: function () {

        jQuery('.rec-wrap').slick({
            touchThreshold: 20,
            // centerMode: true,
            // variableWidth: false,
            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',

            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });


    }, templatetwo: function () {

        $("[data-fancybox]").fancybox({
            thumbs: false,
            hash: true,
            loop: true,
            keyboard: true,
            toolbar: true,
            animationEffect: false,
            arrows: true,
            clickContent: true,
            closeBtn: true
        });

        $(window).on('uti-device-changed', function () {
            loadgal();
        });
        var galnotloaded = true;
        setTimeout(function(){
            if(galnotloaded)
            {
                loadgal();
            }
        },2000);


        function loadgal() {

            galnotloaded = false;
            if (UTI.isdesktop) {

                if ($('.gallery-wrap-new .slick-initialized').length) {
                   $('.gallery-big').slick('unslick');
                }


                $('.gallery-big').append('<div class="slide-desk"></div>');
                $('.slide-desk').append($('.gallery-wrap-new .slide'));

                $('.gallery-big').prepend('<div class="two-desk"></div>');
                $('.two-desk').append($('.gallery-wrap-new .other'));

                jQuery('.slide-desk').slick({
                    touchThreshold: 20,
                    dots: true,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 1
                });
            }
            else {
                if ($('.slide-desk').length) {
                    $('.slide-desk').slick('unslick');
                    $('.gallery-big').append($('.gallery-wrap-new .other'));
                    $('.gallery-big').append($('.gallery-wrap-new .slide'));
                    $('.slide-desk').remove();
                    $('.two-desk').remove();
                }

                $('.gallery-big').slick({
                    touchThreshold: 20,
                    dots: true,  // variableWidth: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });
            }

        }

    },
    upsells: function () {


        var upsellid = "";

        $('body').on('click', '.product-top .details-wrap .add-to-cart button', function (e) {

            if(typeof ttq !== 'undefined')
            {
                ttq.track('AddToCart');
            }

            if($('.upsell-slide').length)
            {
                e.preventDefault();
                e.stopPropagation();
                $('body').append('<div class="siteloader"></div>');

                var qtys = parseInt($('#select2-Quantity-container').text());
                var maincolor = $('.main-color').length?' ('+ $('.main-color').text()+')':'';

                $('.upsell-slide .ptext').html(qtys+" x <span class='title'>"+$('.details-wrap h1').text()+maincolor+"</span> ADDED TO YOUR CART");

                var productid = $('[data-product-select] option:selected').attr('value');
                var datas = 'id=' + productid + "&quantity="+qtys;


                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: datas,
                    success: function (itemData) {
                        $('html').addClass('activeupsell');
                        $('.siteloader').remove();

                        $.getJSON('/cart.js', function (cart) {
                            PROJ.ajaxcart.updateCart();
                        });

                    },
                    error: function (XMLHttpRequest) {
                        $('.siteloader').remove();
                    }
                });
            }

        });



        $('body').on('click', '.upsell-slide .closeit, .upsell-slide .backs', function (e) {
            $('html').removeClass('activeupsell');
            $('body').addClass('mini-cart');
        });

        $('body').on('click', '[data-directadd-upsell]', function (e) {


            e.preventDefault();
            e.stopPropagation();

            var productid = $('[data-product-select] option:selected').attr('value');
            var upsellid = $('[data-directadd-upsell]').attr('data-directadd-upsell');


            var datas = "updates[" + productid + "]=" + 0 + "&";
            datas += "updates[" +upsellid+ "]=" + 1 + "&";

            $('body').append('<div class="siteloader"></div>');


            // Add to cart.
            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: datas,
                dataType: 'json',
                success: function () {
                    PROJ.ajaxcart.updateCart();
                    $('.siteloader').remove();
                    $('html').removeClass('activeupsell');
                    $('body').addClass('mini-cart');
                }
            });

        });




    }
};




"use strict"

var PROJ = (typeof PROJ === 'object') ? PROJ : {};


PROJ.ajaxcart = {
    VAR: {},

    init: function () {
        var _this = this;
        _this.updateCart();

        $('body').on('click', '#mini-cart .close-wrap .close', function (e) {
            e.preventDefault();
            $('body').removeClass('mini-cart');
        });


        //activate free gift with chkecnbox

        $('body').on('change', '#fgifts', function (e) {
            if(this.checked) {
               $('.free-items-box .dum').hide();
               $('.free-items-box .org').show();
            }else
            {
                $('.free-items-box .dum').show();
                $('.free-items-box .org').hide();
            }
        });

        $('body').on('click', '.nav_cart', function (e) {
            e.preventDefault();
            $('body').addClass('mini-cart');
        });


        $('body').on('click', '[data-directadd]', function (e) {
            e.preventDefault();
            _this.addItem($(this).attr('data-directadd'));
        });

        $('body').on('click', '.qty-step-btn', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = par.attr('data-count');
            if ($(this).find('.icon-minus').length) {
                qty--;
                if (qty < 0) qty = 0;
            }
            else {
                qty++;
            }
            _this.updateItem(par.attr('data-proid'), qty);

            setTimeout(function(){
                if($('body').hasClass('template-cart'))
                {
                    location.reload(true);
                }
            },500);


        });

        $('body').on('click', '.incart .remove', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = 0;
            _this.updateItem(par.attr('data-proid'), qty);
        });


        // removing upsell
        $('body').on('click', '.remove.removeupsell', function (e) {
            e.preventDefault();
            $('#mini-cart').addClass("hide-upsell");
            jQuery.cookie("hideupsells","true");
        });

        $('body').on('click', '.show-upsell', function (e) {
            e.preventDefault();
            $('#mini-cart').removeClass("hide-upsell");
            jQuery.cookie("hideupsells","false");
        });

        $('body').on('click', '.choose .no', function (e) {
            e.preventDefault();
            $('.sure-nogift').removeClass('active');
            $('.free-box').addClass('hili');
            setTimeout(function(){
            setTimeout(function(){
                $('.free-box').removeClass('hili');
            },1500);
            },500);
        });

        $('body').on('submit','#minicheckout', function (e) {
            if( $('.sure-nogift').length)
            {
                e.preventDefault();
                $('.sure-nogift').addClass('active');
            }
        })


        $('form[action="/cart/add"]').on('submit', (function (e) {
        //$('body').on('submit', 'form[action="/cart/add"]', (function (e) {

            e.preventDefault();
            var $addToCartForm = $(this);
            var $addToCartBtn = $('.cart-btn button');
            $('#mini-cart').addClass('loading');

            $addToCartBtn.addClass('disabled').prop('disabled', true);
            $('body').addClass('mini-cart');

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function (itemData) {
                    $addToCartBtn.removeClass('disabled').prop('disabled', false);
                    _this.updateCart();
                },
                error: function (XMLHttpRequest) {
                    _this.updateCart();

                }
            });
            return false;

        }));


    },

    updateCart: function () {
        var _this = this;
        $.get("/cart?view=mini", function (data) {

            $('#mini-cart .ajax_place').html($(data));
            $('.offer-line.cart p').html($(data).find('.free-ship').html());

            var counti = "";
            if ($('.mini-header').attr('data-icount') != "0") {
                counti = $('.mini-header').attr('data-icount');
            }

            $('.nav_cart span').text(counti);

        }).done(function () {

           $('#mini-cart').removeClass('loading');

           //check for product limit

            if($('#mini-cart [data-limit]').length)
            {
                $('#mini-cart [data-limit]').each(function(){
                    var limit = parseInt($(this).attr('data-limit'));
                    if(parseInt($(this).attr('data-count'))>limit)
                    {
                        _this.updateItem($(this).attr('data-proid'), limit);
                    }

                });


            }




        });
    },

    addItem: function (id) {
        var _this = this;
        $('#mini-cart').addClass('loading');
        $('body').addClass('mini-cart');

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    }, updateItem: function (id, le) {
        var _this = this;
        $('#mini-cart').addClass('loading');

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + le + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    }


};


$(document).ready(function () {
    PROJ.ajaxcart.init();

    var $addToCartBtn = $('.cart-btn button');


    $('body').on('submits', 'form[action="/cart/add"]', (function (e) {

        // $('form[action="/cart/add"]').submit(function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);

        $addToCartBtn.addClass('disabled').prop('disabled', true);
        // Add to cart.
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: $addToCartForm.serialize(),
            success: function (itemData) {
                $addToCartBtn.removeClass('disabled').prop('disabled', false);

                $('body').append('<div class="cart-added"><div class="box"><a class="close" href="#"></a><h2>IT\'S IN THE BAG</h2><a class="cont" href="#">Continue Shopping</a><a href="/cart" class="checkout"><span>CHECKOUT OUT NOW</span></a></div></div>');
                setTimeout(function () {
                    $('.cart-added').addClass('open');
                }, 100);


                updateicon();

            },
            error: function (XMLHttpRequest) {
                console.log('product adder');

            }
        });
        return false;


    }));


    function updateicon() {

    }

    $('body').on('click', '.cart-added .close,.cart-added .cont', function (e) {
        e.preventDefault();
        $('.cart-added').removeClass('open');
        setTimeout(function () {
            $('.cart-added').remove();
        }, 1000);

    });


});



var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.hero = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1920,
        heroHeight: 845,
        maxWidth: 1500
    },
    init: function () {
        var _this = this;
        var heinter =  parseInt($('.hero-slider').attr('data-slideshow-speed'))*1000;
        var slideit = true;
        if(heinter == 0) slideit = false;

        $('.hero-slider').slick({


            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',


            pauseOnHover: false, slidesToShow: 1, slidesToScroll: 1, dots: true, arrows: true,
            autoplay: slideit,
            autoplaySpeed: heinter, infinite: true,
            responsive: [
                {
                    breakpoint: 869,
                    settings: {
                        arrows: false
                    }
                }
            ]

        });



        $(window).on('uti-width-changed', function () {
            var videocontainer = $('.hero-vid');
            videocontainer.width($(window).width());
            if (UTI.isdesktop)
            {
                videocontainer.height($(window).width() * (824/1920 ));
            }
            else
            {
                videocontainer.height($(window).width() * (750/500 ));
            }
        })


        $(window).on('uti-device-changed', function () {

            var newmp4 = $('.hero-sou').attr('data-m');
            if (UTI.isdesktop) {
                newmp4 = $('.hero-sou').attr('data-d');
            }

            var videocontainer = $('.hero-vid');
            var videosource = $('.hero-sou');

            if(videocontainer.length)
            {
                videocontainer.get(0).pause();
                videosource.get(0).setAttribute('src', newmp4);
                videocontainer.get(0).load();
                //videocontainer.setAttribute('poster', newposter); //Changes video poster image
                videocontainer.get(0).play();
            }



        });
    }

};


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
